/**
 * ChatGPT Ads Measurement Pixel helpers (browser only).
 * Fires items_added and checkout_started. order_created is checkout-only
 * (Shopify Customer Events pixel — see tools/chatgpt-ads-checkout-pixel.js).
 */
(function () {
  function measure(name, data, options) {
    if (typeof window.oaiq !== 'function') return;
    if (options) window.oaiq('measure', name, data, options);
    else window.oaiq('measure', name, data);
  }

  function money(value) {
    var n = Number(value);
    return Number.isFinite(n) ? Math.round(n) : 0;
  }

  function currencyCode(cart) {
    return (cart && cart.currency) || (window.GYMSTACK_OAIQ && window.GYMSTACK_OAIQ.currency) || 'GBP';
  }

  function itemContents(item, cart) {
    return {
      id: String(item.product_id || item.variant_id || ''),
      name: item.product_title || item.title || '',
      content_type: 'product',
      quantity: money(item.quantity) || 1,
      amount: money(item.final_line_price || item.line_price || item.price),
      currency: currencyCode(cart)
    };
  }

  function fetchCart() {
    var url = (window.theme && theme.routes && theme.routes.cart) ? theme.routes.cart + '.js' : '/cart.js';
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error(String(res.status));
      return res.json();
    });
  }

  function measureItemsAdded(variantId) {
    fetchCart()
      .then(function (cart) {
        var item = (cart.items || []).find(function (row) {
          return row.variant_id === variantId;
        }) || (cart.items || [])[0];
        if (!item) return;
        measure('items_added', {
          type: 'contents',
          amount: money(item.final_line_price || item.line_price || item.price),
          currency: currencyCode(cart),
          contents: [itemContents(item, cart)]
        });
      })
      .catch(function () {});
  }

  function measureCheckoutStarted() {
    fetchCart()
      .then(function (cart) {
        measure('checkout_started', {
          type: 'contents',
          amount: money(cart.total_price),
          currency: currencyCode(cart),
          contents: (cart.items || []).map(function (item) {
            return itemContents(item, cart);
          })
        });
      })
      .catch(function () {});
  }

  document.addEventListener('on:cart:add', function (evt) {
    measureItemsAdded(evt.detail && evt.detail.variantId);
  });

  document.addEventListener('click', function (evt) {
    var target = evt.target && evt.target.closest
      ? evt.target.closest('[name="checkout"], a[href*="/checkout"]')
      : null;
    if (!target || target.disabled) return;
    measureCheckoutStarted();
  }, true);

  function syncConsent() {
    try {
      var privacy = window.Shopify && Shopify.customerPrivacy;
      if (!privacy || typeof window.oaiq !== 'function') return;
      var allowed = true;
      if (typeof privacy.analyticsProcessingAllowed === 'function') {
        allowed = privacy.analyticsProcessingAllowed() || privacy.marketingAllowed();
      }
      window.oaiq('consent', Boolean(allowed));
    } catch (e) {}
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) syncConsent();
    });
  }
})();
